<template>
  <div class="list-view list-view-v3">
    <div
      id="active-items-tab"
      class="tab-content is-active"
      v-if="$store.state.courses.length > 0"
    >
      <div class="list-view-inner">
        <!--Item-->
        <template v-for="(item, index) in $store.state.courses"
          ><Course :item="item" :index="index"></Course
        ></template>
      </div>
    </div>

    <div class="list-view-inner" v-if="$store.state.courses.length == 0">
      <div
        class="page-placeholder custom-text-filter-placeholder"
        data-filter-hide=""
      >
        <div class="placeholder-content">
          <img
            class="light-image"
            src="/static/img/illustrations/placeholders/thinking-canvas.svg"
            alt=""
          />
          <img
            class="dark-image"
            src="/static/img/illustrations/placeholders/thinking-canvas-dark.svg"
            alt=""
          />
          <h3>Henüz Hiç Eğitim Yok</h3>
          <p class="">Kurs aldığın zaman burada görünecektir.</p>
        </div>
      </div>
    </div>

    <div
      class="row"
      v-if="
        videos &&
        videos.uyari &&
        videos.neler &&
        videos.merhaba &&
        $store.state.user.foreign_user_id != null
      "
    >
      <div class="col-md-4 position-relative">
        <a
          :href="videos.merhaba"
          class="
            btn btn-circle btn-default btn-play
            ripple
            mx-auto
            mb-5
            position-absolute
            circle
          "
          style="top: 50%; right: 30%; z-index: 3"
          data-fancybox
          ><i class="fas fa-play fa-3x"></i
        ></a>
        <img src="/static/1.jpg" class="w-100" />
      </div>

      <div class="col-md-4 position-relative">
        <a
          :href="videos.neler"
          class="
            btn btn-circle btn-default btn-play
            ripple
            mx-auto
            mb-5
            position-absolute
            circle
          "
          style="top: 50%; right: 30%; z-index: 3"
          data-fancybox
          ><i class="fas fa-play fa-3x"></i
        ></a>
        <img src="/static/2.jpg" class="w-100" />
      </div>

      <div class="col-md-4 position-relative">
        <a
          :href="videos.uyari"
          class="
            btn btn-circle btn-default btn-play
            ripple
            mx-auto
            mb-5
            position-absolute
            circle
          "
          style="top: 50%; right: 30%; z-index: 3"
          data-fancybox
          ><i class="fas fa-play fa-3x"></i
        ></a>
        <img src="/static/3.jpg" class="w-100" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";
import axios from "axios";
import Course from "../components/Course.vue";
import _ from "lodash";

export default {
  components: { Course },
  name: "Courses",
  data() {
    return {
      videos: {
        merhaba: false,
        uyari: false,
        neler: false,
      },
      moment,
      lodash: _,
      activePane: null,
      steps: [
        {
          target: ".buttons", // We're using document.querySelector() under the hood
          header: {
            title: "Haydi Başlayalım!",
          },
          content: `Eğitimin ilk adımına başlamak için buraya tıklayarak başlayabilirsin.`,
        },
        {
          target: ".repeat", // We're using document.querySelector() under the hood
          header: {
            title: "Tekrarları Unutma",
          },
          content: `Bitirdiğin her adımın tekrarını yapmayı ihmal etme.`,
        },
      ],
      bg: 1,
      images: [
        {
          start: 1,
          stop: 5,
          image: 1,
        },
        {
          start: 6,
          stop: 10,
          image: 2,
        },
        {
          start: 11,
          stop: 14,
          image: 3,
        },
        {
          start: 15,
          stop: 18,
          image: 4,
        },
        {
          start: 19,
          stop: 21,
          image: 5,
        },
      ],
    };
  },
  methods: {
    getStart(finished_day, total_day) {
      var start = Math.max(finished_day - 2, 1);
      return [start, start + 1, start + 2, start + 3, start + 4].filter(
        (x) => x <= total_day
      );
    },

    hack(item) {},
  },
  mounted() {
    axios.get("course/list").then((res) => {
      this.$store.state.courses = this.$prepareCourses(res.data.data);
    });
  },
  created() {
    moment.locale(this.$i18n.locale);

    axios
      .post("course/video", {
        bucket_name: "hizli_okuma",
        video: "KURS VİDEOLARI/Merhaba.mp4",
      })
      .then((res) => {
        this.videos.merhaba = res.data.data;
      });

    axios
      .post("course/video", {
        bucket_name: "hizli_okuma",
        video: "KURS VİDEOLARI/NE YAPACAĞIZ.mp4",
      })
      .then((res) => {
        this.videos.neler = res.data.data;
      });

    axios
      .post("course/video", {
        bucket_name: "hizli_okuma",
        video: "KURS VİDEOLARI/UYARILAR.mp4",
      })
      .then((res) => {
        this.videos.uyari = res.data.data;
      });
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/Courses.vue